import * as applicationActions from 'actions/application.js'
import { supportParameters, searchDeprecated } from 'services'
import { supportParameterSchema } from 'schemas/supportParameter'

export const GET_SUPPORT_PARAMETER = 'GET_SUPPORT_PARAMETER'
export const stubGetSupportParam = (id) =>
  applicationActions.apiActionStub({
    asyncFn: supportParameters.getSupportParameter,
    successActionType: GET_SUPPORT_PARAMETER,
    id,
    schema: supportParameterSchema,
  })

export const getSupportParam = ({ supportParameterNumber }) =>
  applicationActions.apiAction({
    asyncFn: supportParameters.getSupportParameter,
    args: { supportParameterNumber },
    successActionType: GET_SUPPORT_PARAMETER,
    id: supportParameterNumber,
    schema: supportParameterSchema,
  })

export const GET_LINKED_RPS = 'GET_LINKED_RPS'
export const getLinkedRPs = ({ supportParameterNumber }) =>
  applicationActions.apiAction({
    asyncFn: searchDeprecated.referenceParametersBySupportParameter,
    args: { supportParameterNumber },
    successActionType: GET_LINKED_RPS,
    id: supportParameterNumber,
  })

export const UPDATE_SUPPORT_PARAM_FIELD = 'UPDATE_SUPPORT_PARAM_FIELD'
export function updateSupportParameterField(fieldName, newValue) {
  return {
    type: UPDATE_SUPPORT_PARAM_FIELD,
    fieldName,
    newValue,
  }
}

export const SET_SELECTED_INPUT = 'SET_SELECTED_INPUT'
export function setSelectedInput({ originalSPUri, input }) {
  return {
    type: SET_SELECTED_INPUT,
    input,
    originalSPUri,
  }
}

export const SET_DETAIL_LEVEL = 'SET_DETAIL_LEVEL'
export function setDetailLevel(detailLevel) {
  return {
    detailLevel,
    type: SET_DETAIL_LEVEL,
  }
}

export const CLEAR_SELECTED_LOGICAL_SLOT = 'CLEAR_SELECTED_LOGICAL_SLOT'
export const SET_SELECTED_LOGICAL_SLOT = 'SET_SELECTED_LOGICAL_SLOT'
export function setSelectedLogicalSlot(slot) {
  return {
    type: SET_SELECTED_LOGICAL_SLOT,
    slot,
  }
}

export const SET_SELECTED_OUTPUT = 'SET_SELECTED_OUTPUT'
export function setSelectedOutput(output) {
  return {
    type: SET_SELECTED_OUTPUT,
    output,
  }
}

export const SAVE_SUPPORT_PARAM = 'SAVE_SUPPORT_PARAM'
export const stubSaveSupportParam = ({ supportParameterNumber, rp }) =>
  applicationActions.apiActionStub({
    asyncFn: supportParameters.saveSupportParameter,
    successActionType: SAVE_SUPPORT_PARAM,
    id: supportParameterNumber,
    args: { supportParameterNumber, rp },
    schema: supportParameterSchema,
  })

export const SELECT_MLOGIC_EDIT_SLOT = 'SELECT_MLOGIC_EDIT_SLOT'
export const selectSlotForEdit = (slot) => ({
  type: SELECT_MLOGIC_EDIT_SLOT,
  slot,
})
export const SELECT_OUTPUT_SLOT_FOR_EDIT = 'SELECT_OUTPUT_SLOT_FOR_EDIT'

export const DUPLICATE_SUPPORT_PARAM_FAIL = 'DUPLICATE_SUPPORT_PARAM_FAIL'
export const DUPLICATE_SUPPORT_PARAM = 'DUPLICATE_SUPPORT_PARAM'
export const stubDuplicateSupportParam = () =>
  applicationActions.apiActionStub({
    asyncFn: supportParameters.duplicateSupportParameter,
    successActionType: DUPLICATE_SUPPORT_PARAM,
    failureActionType: DUPLICATE_SUPPORT_PARAM_FAIL,
    id: 'duplicateSupportParameter',
    schema: supportParameterSchema,
  })

export const duplicateSPWithPromise = (originalSupportParameter) => (
  dispatch
) =>
  new Promise((resolve, reject) => {
    dispatch(
      applicationActions.apiAction({
        asyncFn: supportParameters.duplicateSupportParameter,
        successActionType: DUPLICATE_SUPPORT_PARAM,
        failureActionType: DUPLICATE_SUPPORT_PARAM_FAIL,
        args: { originalSupportParameter },
        id: originalSupportParameter.uri,
        schema: supportParameterSchema,
        resolve,
      })
    )
  })

export const duplicateSupportParameter = (originalSupportParameter) =>
  applicationActions.apiAction({
    asyncFn: supportParameters.duplicateSupportParameter,
    successActionType: DUPLICATE_SUPPORT_PARAM,
    failureActionType: DUPLICATE_SUPPORT_PARAM_FAIL,
    args: { originalSupportParameter },
    id: originalSupportParameter.uri,
    schema: supportParameterSchema,
  })

export const CANCEL_SUPPORT_PARAM_EDIT = 'CANCEL_SUPPORT_PARAM_EDIT'
export const cancelSupportParameterEdit = (supportParameter) => ({
  type: CANCEL_SUPPORT_PARAM_EDIT,
  supportParameter,
})

export const EDIT_SUPPORT_PARAM = 'EDIT_SUPPORT_PARAM'
export function editSupportParam(currentSPUri) {
  return {
    type: EDIT_SUPPORT_PARAM,
    currentSPUri,
  }
}

export const ACTIVATE_SUPPORT_PARAM = 'ACTIVATE_SUPPORT_PARAM'
export const activateSupportParam = ({ id, supportParameter }) =>
  applicationActions.apiAction({
    successActionType: ACTIVATE_SUPPORT_PARAM,
    asyncFn: supportParameters.activateSupportParameter,
    id,
    args: { supportParameter },
    schema: supportParameterSchema,
  })
export const SUPPORT_PARAM_ACTIVATION_ERROR = 'SUPPORT_PARAM_ACTIVATION_ERROR'
export const SP_ACTIVATED = 'SP_ACTIVATED'

export const UPDATE_MLOGIC_SLOT_VALUE = 'UPDATE_MLOGIC_SLOT_VALUE'
export const updateMlogicSlotValue = (fieldName, newValue) => ({
  type: UPDATE_MLOGIC_SLOT_VALUE,
  fieldName,
  newValue,
})

export const SET_MLOGIC_OUTPUT_RESULT = 'SET_MLOGIC_OUTPUT_RESULT'
export const setMLogicOutputResult = (resultSlot, value) => ({
  type: SET_MLOGIC_OUTPUT_RESULT,
  resultSlot,
  value,
})

export const SET_SLOT_EDIT_DISPLAY_MODE = 'SET_SLOT_EDIT_DISPLAY_MODE'
export const setSlotEditDisplayMode = (newMode) => ({
  type: SET_SLOT_EDIT_DISPLAY_MODE,
  newMode,
})

export const SET_CURR_SP_FIELD_VALIDITY = 'SET_CURR_SP_FIELD_VALIDITY'
export const setCurrentFieldValidity = (
  isValidForSaving,
  fieldName,
  errorMsg,
  id
) => ({
  type: SET_CURR_SP_FIELD_VALIDITY,
  isValidForSaving,
  fieldName,
  errorMsg,
  id,
})

export const SET_SLOT_PROPERTIES = 'SET_SLOT_PROPERTIES'
export const setSlotProperties = (props) => ({
  type: SET_SLOT_PROPERTIES,
  ...props,
})

export const SET_SELECTED_SLOT = 'SET_SELECTED_SLOT'
export const setSelectedSlot = (id) => ({
  type: SET_SELECTED_SLOT,
  id,
})
